import PropTypes from 'prop-types';
import AuthService from '../services/authService';
import Navigation from '../services/NavigationService';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const isAuthenticated = AuthService._getAccessToken();


  if (isAuthenticated) {
    return Navigation.navigateToHome();
  }

  return <>{children}</>;
}
